import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { Spinner } from './Spinner';
import { FlexRow, LargeText } from '../content';
const FullScreenSpinner = _ref => {
  let {
    label,
    value
  } = _ref;
  let content = null;
  if (label) {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CircularProgress, {
      variant: "determinate",
      color: "primary",
      size: 120,
      value: value,
      style: {
        position: 'absolute',
        top: 'calc(50% - 60px)',
        left: 'calc(50% - 60px)'
      }
    }), /*#__PURE__*/React.createElement(LargeText, {
      margin: "auto"
    }, label));
  } else {
    content = /*#__PURE__*/React.createElement(Spinner, null);
  }
  return /*#__PURE__*/React.createElement(FlexRow, {
    margin: 0,
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: 4,
    top: 0,
    left: 0,
    backgroundColor: "rgba(255,255,255,0.8)"
  }, content);
};
export { FullScreenSpinner };